import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * USERS notification formatter
 * Extends notification with a link to the user detail page.
 * Payload is expected to carry at least { id, fullName, email }.
 */
export default class UsersFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const payload = notification.payload
    const id = payload?.id
    const company = payload?.company

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    if (id) {
      additionalParams.push({
        key: 'user_registration_notification_message',
        values: { id }
      })
    }

    if (company) {
      additionalParams.push({
        key: 'user_registration_notification_company',
        values: { company }
      })
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/users/${id}` : undefined
    }
  }
}
